import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { TEST_IDS } from '../testIds';

const useDosimetryFieldsConfig = ({ t, formData, handleBlurValidation }: any) => {
    const [dosimetryFieldsConfig, setDosimetryFieldsConfig] = useState<FieldConfig[]>([]);

    useEffect(() => {
        const fieldsConfig: FieldConfig[] = [
            {
                type: 'text',
                label: t('radiologicalEquipmentForm.inputs.dosimetry.cuit') as string,
                name: 'cuit',
                required: true,
                value: formData.cuit,
                disabled: false,
                helperText: t('radiologicalEquipmentForm.inputs.dosimetry.cuit') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                maxLength: 11,
                minLength: 11,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.newRadiologicalEquipment.dosimetryFormFields.cuit,
                validations: [{ name: 'required' }, { name: 'fixedLength', param: 11 }]
            },
            {
                type: 'text',
                label: t('radiologicalEquipmentForm.inputs.dosimetry.dosimetryType') as string,
                name: 'dosimetryType',
                required: true,
                value: formData.dosimetryType,
                maxLength: 100,
                minLength: 5,
                disabled: false,
                gridSpace: { xs: 12 },
                onBlurValidation: handleBlurValidation,
                testID: TEST_IDS.newRadiologicalEquipment.dosimetryFormFields.dosimetryType,
                validations: [
                    { name: 'required' },
                    { name: 'minLength', param: 5 },
                    { name: 'maxLength', param: 100 }
                ]
            },
            {
                type: 'text',
                label: t('radiologicalEquipmentForm.inputs.dosimetry.dosimetryMethod') as string,
                name: 'dosimetryMethod',
                required: true,
                maxLength: 100,
                minLength: 5,
                value: formData.dosimetryMethod,
                disabled: false,
                gridSpace: { xs: 12 },
                onBlurValidation: handleBlurValidation,
                testID: TEST_IDS.newRadiologicalEquipment.dosimetryFormFields.dosimetryMethod,
                validations: [
                    { name: 'required' },
                    { name: 'minLength', param: 5 },
                    { name: 'maxLength', param: 100 }
                ]
            },
            {
                type: 'text',
                label: t('radiologicalEquipmentForm.inputs.dosimetry.personalQuantity') as string,
                name: 'personalQuantity',
                required: true,
                value: formData.personalQuantity,
                disabled: false,
                inputType: 'number',
                gridSpace: { xs: 12 },
                onBlurValidation: handleBlurValidation,
                testID: TEST_IDS.newRadiologicalEquipment.dosimetryFormFields.personalQuantity,
                validations: [{ name: 'required' }, { name: 'minValue', param: 0 }]
            }
        ];

        setDosimetryFieldsConfig(fieldsConfig);
    }, [t]);

    return {
        dosimetryFieldsConfig
    };
};

export default useDosimetryFieldsConfig;
